import { render, staticRenderFns } from "./TipsInfo.vue?vue&type=template&id=2cf0cf1c&scoped=true&"
import script from "./TipsInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TipsInfo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TipsInfo.vue?vue&type=style&index=0&id=2cf0cf1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0cf1c",
  null
  
)

export default component.exports